// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Standard session start & stop event names
const SESSION_START_EVENT = '_session.start';
const SESSION_STOP_EVENT = '_session.stop';

export { SESSION_START_EVENT, SESSION_STOP_EVENT };
//# sourceMappingURL=constants.mjs.map
